export const ThemeColors = {
    textPrimary: '#fff',
    fontFamily: "Mulish",
}